import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { EMULATOR, EMULATOR_PROJECT_ID, FUNCTIONS_REGION } from "./fields";

/** E2E only: VITE_USE_EMULATORS=1 points Auth, Firestore and Functions at the local emulators. */
export const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === "1";

// Public web client config (same as the old admin and the scanner). Not a secret.
const config = {
  apiKey: "AIzaSyCY9Cpu7Cic73pJEhF--hTn_Pw56GsECr0",
  authDomain: "ticketvalidator.firebaseapp.com",
  projectId: "ticketvalidator",
  appId: "1:740784835521:web:476d7468595597aa05fd40",
  messagingSenderId: "740784835521",
};

// A demo-* project id can never reach a real Firebase project, even if an emulator is missing.
export const app = initializeApp(USE_EMULATORS ? { ...config, projectId: EMULATOR_PROJECT_ID } : config);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);

if (USE_EMULATORS) {
  connectAuthEmulator(auth, `http://${EMULATOR.host}:${EMULATOR.auth}`, { disableWarnings: true });
  connectFirestoreEmulator(db, EMULATOR.host, EMULATOR.firestore);
  connectFunctionsEmulator(functions, EMULATOR.host, EMULATOR.functions);
}
